<template>
  <!-- 成功页面容器 -->
  <div class="success-container">
    <!-- 背景装饰效果 -->
    <div class="background"></div>
    <!-- 内容包装器 -->
    <div class="content-wrapper">
      <!-- 奖品信息卡片 -->
      <div class="prize-box">
        <!-- 卡片头部 -->
        <div class="prize-header">
          <h1 class="prize-title">领奖成功</h1> <!-- 页面标题 -->
          <div class="timer">一窥究竟 3:16</div> <!-- 倒计时提示 -->
        </div>

        <!-- 领奖消息 -->
        <div class="prize-message">
          您的领奖链接已自动发送
        </div>

        <!-- 游戏手柄复制按钮 -->
        <div class="controller-btn" @click="copyLink">
          <div class="controller-shape">
            <div class="controller-left"></div> <!-- 左侧按钮 -->
            <div class="controller-right"></div> <!-- 右侧按钮 -->
            <div class="controller-middle"></div> <!-- 中间按钮 -->
          </div>
          <div class="copy-text">点击复制领奖链接</div>
        </div>

        <!-- 提示信息 -->
        <div class="instructions">
          <p>复制后请在浏览器中打开</p>
          <p>奖品将在X天内发放</p>
        </div>

        <!-- 公众号关注提示 -->
        <div class="follow-prompt">
          <div class="qrcode-placeholder"></div> <!-- 二维码占位符 -->
          <div class="follow-text">
            <p>关注公众号获取更多福利</p>
            <button class="follow-btn">已关注</button> <!-- 关注按钮 -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import globalStore from '../utils/globalStore.js';

export default {
  // 组件名称
  name: 'Success',
  
  // 组件数据
  data() {
    return {
      领奖链接: 'https://example.com/claim-prize' // 领奖链接，实际项目中应从后端获取
    }
  },
  
  // 组件方法
  methods: {
    // 领取奖品
    claimPrize() {
      // 在实际应用中，这里应该调用API来处理奖品领取
      console.log('用户点击了领取奖品');
      
      // 模拟跳转到奖品领取页面或显示领取表单
      // 实际应用中可能需要获取用户信息并提交
      alert('即将跳转到奖品领取页面');
      window.open(this.领奖链接, '_blank');
    },
    
    // 查看抽奖记录
    viewRecords() {
      this.$router.push({
        path: '/records',
        query: globalStore.getUrlParams()
      });
    },
    
    // 返回首页
    goHome() {
      this.$router.push({
        path: '/',
        query: globalStore.getUrlParams()
      });
    }
  }
}
</script>

<style scoped>
/* 成功页面容器 */
.success-container {
  min-height: 100vh; /* 最小高度为视口高度 */
  background: linear-gradient(135deg, #1a2a6c 0%, #b21f1f 50%, #fdbb2d 100%); /* 三色渐变背景 */
  padding: 20px; /* 内边距 */
}

/* 背景装饰效果 */
.background {
  position: absolute; /* 绝对定位 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: radial-gradient(circle at 20% 30%, rgba(255,255,255,0.1) 0%, transparent 30%),
                    radial-gradient(circle at 80% 70%, rgba(255,255,255,0.1) 0%, transparent 30%);
  /* 两个径向渐变创建光晕效果 */
}

/* 内容包装器 */
.content-wrapper {
  position: relative; /* 相对定位 */
  z-index: 1; /* 确保内容在背景之上 */
  max-width: 500px; /* 最大宽度 */
  margin: 0 auto; /* 水平居中 */
  padding-top: 50px; /* 顶部内边距 */
}

/* 奖品信息卡片 */
.prize-box {
  background: white; /* 白色背景 */
  border-radius: 20px; /* 圆角边框 */
  padding: 30px; /* 内边距 */
  box-shadow: 0 10px 30px rgba(0,0,0,0.2); /* 阴影效果 */
  position: relative; /* 相对定位 */
  overflow: hidden; /* 溢出隐藏 */
}

/* 卡片头部 */
.prize-header {
  display: flex; /* 弹性布局 */
  justify-content: space-between; /* 两端对齐 */
  align-items: center; /* 垂直居中 */
  margin-bottom: 30px; /* 底部外边距 */
}

/* 页面标题 */
.prize-title {
  font-size: 28px;
  font-weight: bold; /* 粗体 */
  color: #ff4d6d; /* 粉色 */
  margin: 0;
}

/* 倒计时提示 */
.timer {
  background: #ffd700; /* 金黄色背景 */
  color: #333;
  padding: 5px 12px;
  border-radius: 15px;
  font-size: 14px;
  font-weight: bold;
}

/* 领奖消息 */
.prize-message {
  text-align: center; /* 文本居中 */
  font-size: 18px;
  color: #333;
  padding: 15px;
  background: #f8f9fa; /* 浅灰色背景 */
  border-radius: 10px;
  margin-bottom: 30px;
}

/* 游戏手柄按钮容器 */
.controller-btn {
  position: relative;
  width: 280px;
  height: 120px;
  margin: 0 auto 30px; /* 水平居中 */
  cursor: pointer; /* 鼠标指针样式 */
}

/* 游戏手柄形状 */
.controller-shape {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #1e88e5 0%, #0d47a1 100%); /* 蓝色渐变 */
  border-radius: 20px;
  box-shadow: 0 5px 15px rgba(30, 136, 229, 0.4); /* 蓝色阴影 */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
}

/* 左右按钮样式 */
.controller-left, .controller-right {
  width: 40px;
  height: 40px;
  background: rgba(255,255,255,0.3); /* 半透明白色 */
  border-radius: 50%; /* 圆形 */
  position: relative;
}

/* 中间按钮样式 */
.controller-middle {
  width: 80px;
  height: 25px;
  background: rgba(255,255,255,0.3); /* 半透明白色 */
  border-radius: 12px;
}

/* 复制提示文本 */
.copy-text {
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%); /* 水平居中 */
  background: #ffeb3b; /* 黄色背景 */
  color: #333;
  padding: 5px 15px;
  border-radius: 15px;
  font-size: 14px;
  font-weight: bold;
}

/* 提示信息 */
.instructions {
  text-align: center;
  margin-bottom: 30px;
}

/* 提示文本样式 */
.instructions p {
  color: #666;
  margin: 8px 0;
  font-size: 14px;
}

/* 公众号关注提示 */
.follow-prompt {
  display: flex;
  align-items: center;
  background: #f8f9fa; /* 浅灰色背景 */
  border-radius: 15px;
  padding: 20px;
  margin-top: 20px;
}

/* 二维码占位符 */
.qrcode-placeholder {
  width: 80px;
  height: 80px;
  background: #e9ecef; /* 更浅的灰色 */
  border-radius: 8px;
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #adb5bd; /* 灰色文本 */
  font-size: 12px;
}

/* 关注文本区域 */
.follow-text {
  flex: 1; /* 占据剩余空间 */
}

/* 关注文本样式 */
.follow-text p {
  margin: 0 0 10px 0;
  color: #495057;
  font-size: 14px;
}

/* 关注按钮 */
.follow-btn {
  background: linear-gradient(135deg, #e91e63 0%, #9c27b0 100%); /* 粉色到紫色渐变 */
  color: white;
  border: none;
  border-radius: 20px;
  padding: 8px 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease; /* 过渡动画 */
}

/* 关注按钮悬停效果 */
.follow-btn:hover {
  transform: translateY(-2px); /* 向上浮动 */
  box-shadow: 0 4px 8px rgba(233, 30, 99, 0.3); /* 增强阴影 */
}
</style>